import { disableApplicationInstanceAppModule } from "../../app/services/eAuthz/DisableApplicationInstanceAppModuleEAuthz"
import { EnableApplicationInstanceAppModule } from "../../app/services/eAuthz/EnableApplicationInstanceAppModule"
import { addEntityGroupGlobalNotificationEAuthz } from "../../app/services/eAuthz/addEntityGroupGlobalNotificationEAuthz"
import { addUserApplicationInstanceAccessEAuthz } from "../../app/services/eAuthz/addUserApplicationInstanceAccess"
import { getAllUserGrantedAppRoleEAuthz } from "../../app/services/eAuthz/getAllUserGrantedAppRoleEAuthz"
import { getApplicationInstance } from "../../app/services/eAuthz/getApplicationInstanceEAuthz"
import { getNotificationConditionTypeEAuthz } from "../../app/services/eAuthz/getNotificationConditionTypeEAuthz"
import { getOrganizationAccessStatus } from "../../app/services/eAuthz/getOrgApplicationAccessStatusEAuthz"
import { getUserApplicationInstanceEAuthz } from "../../app/services/eAuthz/getUserApplicationInstance"
import { getUserGrantedAppRoleEAuthz } from "../../app/services/eAuthz/getUserGrantedAppRoleEAuthz"
import { grantAppRoleToUserEAuthz } from "../../app/services/eAuthz/grantAppRoleToUserEAuthz"
import { RevokeAppRoleFromUser } from "../../app/services/eAuthz/revokeAppRoleFromUserEAuthz"
import { updateApplicationInstanceAppModule } from "../../app/services/eAuthz/updateApplicationInstanceAppModuleEAuthz"
import { updateFirmStaffRole } from "../../app/services/eAuthz/updateFirmStaffRole"
import { updateUserApplicationInstanceAccess } from "../../app/services/eAuthz/updateUserApplicationInstanceAccess"
import { logEvent } from "../../utils/LogEvents"
import { globalNotificationTypes } from "../constants/action-types"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "./app"

const setErrorNotificationConditionTypes = (error) => {
  return {
    type: globalNotificationTypes.NOTIFICATION_CONDITION_TYPES_FAILURE,
    payload: error,
  }
}
const setSuccessNotificationConditionTypes = (data) => {
  return {
    type: globalNotificationTypes.NOTIFICATION_CONDITION_TYPES_SUCCESS,
    payload: data,
  }
}
export const setRequestNotificationConditionTypes = () => {
  return {
    type: globalNotificationTypes.NOTIFICATION_CONDITION_TYPES_REQUEST,
  }
}

export const getNotificationConditionType = () => {
  return async (dispatch) => {
    try {
      const response = await getNotificationConditionTypeEAuthz()
      dispatch(setSuccessNotificationConditionTypes(response.data?.data))
    } catch (error) {
      dispatch(setErrorNotificationConditionTypes())
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const getOrganizationAccess = (id) => {
  return async (dispatch) => {
    try {
      const response = await getOrganizationAccessStatus(id)
      if (!response.data?.data) return "NotFound"
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const getApplicationInstanceEAuthz = (instanceId) => {
  return async (dispatch) => {
    try {
      const response = await getApplicationInstance(instanceId)

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const updateAppInstanceAppModuleEAuthz = (body) => {
  return async (dispatch) => {
    try {
      const response = await updateApplicationInstanceAppModule(body)
      logEvent("CGI - updateApplicationInstanceAppModule", {
        body: body,
        response: response,
      })

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const disableAppInstanceAppModuleEAuthz = (body) => {
  return async (dispatch) => {
    try {
      const response = await disableApplicationInstanceAppModule(body)
      logEvent("CGI - disableApplicationInstanceAppModule", {
        body: {
          body,
        },
        response: response,
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Deshabilitación exitosa"))

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const EnableApplicationInstanceAppModuleEAuthz = (body) => {
  return async (dispatch) => {
    try {
      const response = await EnableApplicationInstanceAppModule(body)
      logEvent("CGI - EnableApplicationInstanceAppModule", {
        body: {
          body,
        },
        response: response,
      })

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const getUserAppRole = (id) => {
  return async (dispatch) => {
    try {
      const response = await getUserGrantedAppRoleEAuthz(id)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}
export const getUserApplicationInstance = (id) => {
  return async (dispatch) => {
    try {
      const response = await getUserApplicationInstanceEAuthz(id)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}
export const getAllUserGrantedAppRole = (applicationInstanceId) => {
  return async (dispatch) => {
    try {
      const response = await getAllUserGrantedAppRoleEAuthz(
        applicationInstanceId,
      )
      return response?.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
      return []
    }
  }
}

export const updateFirmStaffRoleEAuthz = (userData) => {
  return async (dispatch) => {
    try {
      const response = await updateFirmStaffRole(userData)
      logEvent("CGI - updateFirmStaffRoleEAuthz", {
        data: {
          userData,
        },
        response: response,
      })
      return response
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const RevokeAppRoleFromUserEAuthz = (userData) => {
  return async (dispatch) => {
    try {
      const response = await RevokeAppRoleFromUser(userData)
      logEvent("CGI - getUserGrantedRoleEAuthz", {
        data: {
          userData,
        },
        response: response,
      })
      return response
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const addUserApplicationInstanceAccess = (userData) => {
  return async (dispatch) => {
    try {
      const response = await addUserApplicationInstanceAccessEAuthz(userData)
      logEvent("CGI - addUserApplicationInstanceAccessEAuthz", {
        data: {
          userData,
        },
        response: response,
      })
      return response
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const grantAppRoleToUser = (userData) => {
  return async (dispatch) => {
    try {
      const response = await grantAppRoleToUserEAuthz(userData)
      logEvent("CGI - grantAppRoleToUserEAuthz", {
        data: {
          userData,
        },
        response: response,
      })
      return response
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}
export const updateUserApplicationInstanceAccessEAuthz = (data) => {
  return async (dispatch) => {
    try {
      const response = await updateUserApplicationInstanceAccess(data)
      logEvent("CGI - updateUserApplicationInstanceAccess", {
        data: {
          data,
        },
        response,
      })
      return response
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
        )
      }
      if (error.response?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.codeMessageLanguage,
          ),
        )
      }
      console.log(error)
    }
  }
}

export const addEntityGroupGlobalNotification = (data) => {
  return async (dispatch) => {
    try {
      const response = await addEntityGroupGlobalNotificationEAuthz(data)
      logEvent("CGI - addEntityGroupGlobalNotificationEAuthz", {
        body: {
          data,
        },
        response: response,
      })

      return response.data?.data
    } catch (error) {
      return null
    }
  }
}
